function cambioRappresentante() {
  return this.openCambioRappresentante()
}

export default {
  bindTo: 'this',
  method: cambioRappresentante
}
